// redux/reducers/categoryModalReducer.js
const initialState = {
    isModalVisible: false,
  };
  
  export const categoryModalReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SHOW_ADD_CATEGORY_MODAL":
        return { ...state, isModalVisible: true };
  
      case "HIDE_ADD_CATEGORY_MODAL":
        return { ...state, isModalVisible: false };
  
      default:
        return state;
    }
  };

  


    export const keywordModalReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SHOW_ADD_KEYWORD_MODAL":
        return { ...state, isModalVisible: true };
  
      case "HIDE_ADD_KEYWORD_MODAL":
        return { ...state, isModalVisible: false };
  
      default:
        return state;
    }
  };
  
